import { render, staticRenderFns } from "./InternalLetters.vue?vue&type=template&id=6aa98af2"
import script from "./InternalLetters.vue?vue&type=script&lang=js"
export * from "./InternalLetters.vue?vue&type=script&lang=js"
import style0 from "./InternalLetters.vue?vue&type=style&index=0&id=6aa98af2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports